<template>
  <div class="w-alert-icon" :class="color">
    <iconify-icon :icon="icon" />
    <iconify-icon :icon="secondaryIcon" v-if="secondaryIcon" class="secondary-icon" />
  </div>
</template>

<script lang="ts">
  export default {
    name: 'WAlertIcon',
    props: {
      color: {
        type: String,
        validator(value: string) {
          return ['primary', 'secondary', 'danger', 'yellow', 'gray'].includes(value);
        },
        default: 'primary',
      },
      icon: { type: String, default: 'fa:question' },
      secondaryIcon: String,
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';

  .w-alert-icon {
    height: 3.5rem;
    width: 3.5rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: $var-primary-lighter;
    color: $var-primary-main;
    border-radius: 50%;
    font-size: 1.5rem;

    &.secondary {
      background-color: $secondary-light;
      color: $secondary-dark;
    }

    &.danger {
      background-color: $communication-danger-light;
      color: $communication-danger;
    }

    &.yellow {
      background-color: $communication-light-yellow;
      color: $communication-dark-yellow;
    }
    &.gray {
      background-color: $bg-light;
      color: $neutral-gray;
    }
    .secondary-icon {
      position: absolute;
      font-size: 0.75rem;
      right: 0.125rem;
      bottom: 0.125rem;
    }
  }
</style>
